import React from 'react'


export default function Pause({ isMobile }: { isMobile: boolean }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={isMobile ? "30" : '40'} height={isMobile ? "30" : '40'} viewBox="0 0 40 40" fill="none">
            <path d="M15 26H18.3333V14H15V26ZM21.6667 14V26H25V14H21.6667Z" fill="white" />
            <circle cx="20" cy="20" r="19" stroke="white" strokeWidth="2" />
        </svg>
    )
}
